import styles from "./style.module.scss";

interface OptionProps {
  value: string;
  title: string;
  icon?: string;
}

interface OptionsDropDownProps {
  id: string;
  options: OptionProps[];
  openSelection: boolean;
  setOpenSelection: (open: boolean) => void;
  onSelect: (option: OptionProps) => void;
  customContainer?: string;
  tabIndex?: number;
  wrapInGlobalWrapper?: boolean;
}

const OptionsDropDown = ({
  id,
  options,
  openSelection,
  setOpenSelection,
  onSelect,
}: OptionsDropDownProps) => {
  if (!openSelection) return null;

  return (
    <div id={id} className={styles.optionsContainer}>
      <div className="p-1.5">
        {options.map((option) => (
          <div
            key={option.value}
            className={
              (styles.optionItem,
              "px-3 py-1.5 cursor-pointer hover:bg-gray-200 rounded-md text-sm")
            }
            onClick={() => {
              onSelect(option);
              setOpenSelection(false);
            }}
          >
            {option.icon && (
              <img src={option.icon} alt="" className={styles.icon} />
            )}
            <span>{option.title}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OptionsDropDown;
